/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetGooseGameItemQueryVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type GetGooseGameItemQuery = {
  gooseGameStoreItem: Pick<
    Types.GooseGameItem,
    | "id"
    | "name"
    | "description"
    | "point_cost"
    | "quantity_available"
    | "user_redemption_limit"
    | "is_sold_out"
  >;
};

export const GetGooseGameItemDocument = gql`
  query GetGooseGameItem($id: Float!) {
    gooseGameStoreItem(id: $id) {
      id
      name
      description
      point_cost
      quantity_available
      user_redemption_limit
      is_sold_out
    }
  }
`;

/**
 * __useGetGooseGameItemQuery__
 *
 * To run a query within a React component, call `useGetGooseGameItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGooseGameItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGooseGameItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGooseGameItemQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGooseGameItemQuery,
    GetGooseGameItemQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetGooseGameItemQuery,
    GetGooseGameItemQueryVariables
  >(GetGooseGameItemDocument, baseOptions);
}
export function useGetGooseGameItemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGooseGameItemQuery,
    GetGooseGameItemQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetGooseGameItemQuery,
    GetGooseGameItemQueryVariables
  >(GetGooseGameItemDocument, baseOptions);
}
export type GetGooseGameItemQueryHookResult = ReturnType<
  typeof useGetGooseGameItemQuery
>;
export type GetGooseGameItemLazyQueryHookResult = ReturnType<
  typeof useGetGooseGameItemLazyQuery
>;
export type GetGooseGameItemQueryResult = ApolloReactCommon.QueryResult<
  GetGooseGameItemQuery,
  GetGooseGameItemQueryVariables
>;
